import * as Yup from 'yup';

export const ProfileEditPersonalInfoFormValidationSchema = Yup.object().shape({
  CitizenshipID: Yup.array()
    .nullable()
    .required('Citizenship field is required'),

  Languages: Yup.array()
    .nullable()
    .test(
      'check-Languages',
      'Please select Language and Level',
      value => value && !value.some(v => !v.language || !v.level)
    )
    .test(
      'unique-Languages',
      'Please remove duplicates',
      value =>
        value &&
        !value.some(
          v =>
            v.language && value.find(c => c !== v && c.language === v.language)
        )
    ),
});
